import {isArray, isObject} from "../../../../funcs";
import BaseRights from "../BaseRights";
import Filter3 from "../../../storage/filter3/Filter3";
import rightsByType from "../rightsByType";


export default class FullGridRights extends BaseRights {
    constructor() {
        super(...arguments);

        // Для удобства приводим к единому знаменателю
        if ( this.params.filter3 ) {
            this.filter = (
                this.params.filter3 instanceof Filter3
                    ? this.params.filter3
                    : new Filter3(this.params.filter3)
            );
        }

        if ( this.params.filter ) {
            this.filter = (
                this.filter
                    ? this.filter.and(this.params.filter)
                    : new Filter3(this.params.filter)
            );
        }

        if ( this.params.sysFilter ) {
            this.filter = (
                this.filter
                    ? this.filter.and(this.params.sysFilter)
                    : new Filter3(this.params.sysFilter)
            );
        }

        this.table = this._getTableName();

        if ( this.params.customPermissions ) {
            const customPermissions = this.params.customPermissions;

            this.customPermissions = {
                create: customPermissions.create,
                remove: customPermissions.remove,
                showForm: customPermissions.showForm,
                toolbar: customPermissions.toolbar,
                columns: {
                    view: {},
                    edit: {}
                }
            };
            customPermissions.columns.forEach((column) => {
                const key = column.key;

                this.customPermissions.columns.view[key] = true;
                if ( column.edit ) {
                    this.customPermissions.columns.edit[key] = true;
                }
            });
        }
    }

    _getTableName() {
        let table = this.params.table;

        // lw-4901 по фильтру пытаемся определить тип записи (если необходимо)
        if ( table in rightsByType && this.filter ) {
            for (let i = 0; i < rightsByType[table].length; i++) {
                let fieldType = Object.keys(rightsByType[table][i])[1];

                let values = [];
                let filterJSON = this.filter.toJSON();

                for (let j = 0; j < filterJSON.length; j++) {
                    if ( isArray(filterJSON[j])
                                && filterJSON[j][0] === fieldType
                                && filterJSON[j][1] === "="
                                && filterJSON[j][2] == rightsByType[table][i][fieldType]
                    ) {
                        values.push(rightsByType[table][i]["TABLE"]);
                    }
                }

                // Если установили однозначное соответствие то будем его использовать, если нет, будем объединять права разных типов (дальше по коду)
                if ( values.length === 1 ) {
                    table = values[0];
                    break;
                }
            }
        }

        return table;
    }

    // Если не установленно однозначное соотвествие то права будут браться по совокупости прав.
    _checkRightByType(table, path = "", pathEnd = "", where) {
        for (let i = 0; i < rightsByType[table].length; i++) {
            if ( !where ) {
                if ( this._checkTreeRight("view", rightsByType[table][i]["TABLE"] + path + pathEnd) ) {
                    return true;
                }
            }
            else if ( rightsByType[table][i]["TABLE"] + path + pathEnd in where ) {
                return true;
            }
        }

        return false;
    }

    checkColumnView(column) {
        if ( system.user.isAdmin() ) {
            return true;
        }

        if ( column == "ID" || column == "plus" || column == "checked" ) {
            return true;
        }

        let table = this.table;
        if ( table == "DATA_CHANGES_LOG" ) {
            return true;
        }

        if ( table == "OPERATION_UNIT_SCOPE" ) {
            table = "OPERATION_UNIT";
        }

        if ( table in BaseRights.EXCLUDE_FROM_RIGHTS_FILTER ) {
            return true;
        }

        if ( this.customPermissions ) {
            return column in this.customPermissions.columns.view;
        }

        if ( table in rightsByType ) {
            return this._checkRightByType(table, ".columns.", column, this.manager.rights.view);
        } else {
            let rightId = table + ".columns." + column;
            return rightId in this.manager.rights.view;
        }
    }

    checkColumnEdit(column) {
        if ( column == "ID" ) {
            return false;
        }

        if ( system.user.isAdmin() ) {
            return true;
        }

        let table = this.table;
        if ( table == "OPERATION_UNIT_SCOPE" ) {
            table = "OPERATION_UNIT";
        }

        if ( this.customPermissions ) {
            return column in this.customPermissions.columns.edit;
        }

        if ( table in rightsByType ) {
            return this._checkRightByType(table, ".columns.", column, this.manager.rights.edit);
        } else {
            let rightId = table + ".columns." + column;
            return rightId in this.manager.rights.edit;
        }
    }

    checkFormView(formName) {
        if ( system.user.isAdmin() ) {
            return true;
        }

        if ( this.customPermissions ) {
            return this.customPermissions.showForm;
        }

        if ( this.table in rightsByType ) {
            return this._checkRightByType(this.table, ".", formName);
        } else {
            const rightId = this.table + "." + formName;
            return this._checkTreeRight("view", rightId);
        }
    }

    checkCreate() {
        if ( this.customPermissions ) {
            return this.customPermissions.create;
        }

        return this._checkElem("add");
    }

    checkEdit() {
        if ( this.customPermissions ) {
            return Object.keys(this.customPermissions.columns.edit).length > 1;
        }

        return this._checkElem("edit");
    }

    checkRemove() {
        if ( this.customPermissions ) {
            return this.customPermissions.remove;
        }

        return this._checkElem("delete");
    }

    _checkElem(rule) {
        if ( system.user.isAdmin() ) {
            return true;
        }
        if ( this.table in rightsByType ) {
            return this._checkRightByType(this.table, `.toolbar.${rule}`, this.manager.rights.edit);
        } else {
            const rightId = `${this.table}.toolbar.${rule}`;
            return rightId in this.manager.rights.edit;
        }
    }

    checkToolbarIcon(iconName) {
        if ( system.user.isAdmin() ) {
            return true;
        }

        if ( this.customPermissions ) {
            return (
                this.customPermissions.toolbar == "all"
                || isObject(this.customPermissions.toolbar)
                && iconName in this.customPermissions.toolbar

            );
        }

        if ( this.table in rightsByType ) {
            return (
                this._checkRightByType(this.table, ".toolbar.", iconName, this.manager.rights.edit)
                    || this._checkRightByType(this.table, ".toolbar.", iconName, this.manager.rights.view)
            );
        }
        else {
            const rightId = this.table + ".toolbar." + iconName;
            return (
                rightId in this.manager.rights.edit
                    || rightId in this.manager.rights.view
            );
        }
    }
}
